export enum VmInstanceOperation {
    GetPowerState = 'GetPowerState',
    Deploy = 'Deploy',
    Destroy = 'Destroy',
    Redeploy = 'Redeploy',
    Restart = 'Restart',
    PowerOn = 'PowerOn',
    PowerOff = 'PowerOff'
  }
  